document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customProduct()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customProduct();
});
$(document).ready(function(){
    customProduct();
})

function customProduct() {
    $('.superBanner').remove();
    var path = window.location.pathname;
    var segments = path.split('/');
    segments = segments.slice(1, 2);
    var shortPath = segments.join('/');
    var selectedBanner = banners[shortPath] || defaultBanner;
    var bannerHTML = `
        <div class="product superBanner">
            <img src="${selectedBanner.image}" alt="${selectedBanner.title}">
            <div class="bannerContent">
                <h2>${selectedBanner.title}</h2>
                <p>${selectedBanner.description}</p>
                <a href="${selectedBanner.buttonLink}" class="btn btn-secondary">${selectedBanner.buttonText}</a>
            </div>
        </div>
    `;
    var products = $(".type-category .product");
    if (products.length === 0) {
        console.warn("Nebyl nalezen žádný produkt, banner se nezobrazí.");
        return;
    }
    if(products.length >= 6) {
        $(products[5]).after(bannerHTML);
    }
    else{
        $(".product:last").after(bannerHTML);
    }

}